module.exports = __webpack_public_path__ + "img/pq-grupo.c6d69949.svg";